"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseApplicationStats = void 0;
class ListResponseApplicationStats {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseApplicationStats.attributeTypeMap;
    }
}
exports.ListResponseApplicationStats = ListResponseApplicationStats;
ListResponseApplicationStats.discriminator = undefined;
ListResponseApplicationStats.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ApplicationStats>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseApplicationStats.js.map